/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_Delete_Error_DescInputs */

const es_feedback_delete_error_desc = /** @type {(inputs: Feedback_Delete_Error_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ocurrió un problema inesperado. Por favor intenta nuevamente.`)
};

const en_feedback_delete_error_desc = /** @type {(inputs: Feedback_Delete_Error_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An unexpected error occurred. Please try again.`)
};

/**
* | output |
* | --- |
* | "An unexpected error occurred. Please try again." |
*
* @param {Feedback_Delete_Error_DescInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const feedback_delete_error_desc = /** @type {((inputs?: Feedback_Delete_Error_DescInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_Delete_Error_DescInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_feedback_delete_error_desc(inputs)
	return en_feedback_delete_error_desc(inputs)
});
export { feedback_delete_error_desc as "feedback.delete.error_desc" }